import { create } from "zustand"

/** Active organization for this browser session; sent as X-Organization-Id. */
interface ActiveOrgState {
  activeOrgId: string | null
  setActiveOrgId: (id: string | null) => void
}

export const useActiveOrgStore = create<ActiveOrgState>((set) => ({
  activeOrgId: null,
  setActiveOrgId: (activeOrgId) => set({ activeOrgId }),
}))
